<template>
  <div class="mod-number">
    <div class="number">
      <a-button
        class="button"
        :disabled="model <= min"
        @click="reduce"
      >
        <a-icon type="minus" />
      </a-button>
      <a-input
        v-model="model"
        class="input"
        :min="min"
        :max="max"
        :disabled="disabled"
        read-only
      >
      </a-input>
      <a-button
        @click="add"
        class="button"
        :disabled="model >= max"
      >
        <a-icon type="plus" />
      </a-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      model: 0
    }
  },
  name: 'input-number',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: -Infinity
    },
    max: {
      type: Number,
      default: Infinity
    },
    disabled: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number,
      default: 1
    },
    title: String
  },
  watch: {
    value (newValue) {
      this.model = newValue
    }
  },
  created: function () {
    this.model = this.value
  },
  methods: {
    reduce () {
      this.change(-this.step)
    },
    add () {
      this.change(this.step)
    },
    change (diff) {
      const { model, min, max } = this
      let value = model - 0

      if (diff) {
        value = model + diff
      }

      if (value < min) {
        value = min
      }

      if (value > max) {
        value = max
      }
      this.model = value
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="less">
.mod-number {
  height: 30px;

  .number {
    line-height: 30px;
    height: 30px;
    vertical-align: text-top;

    .button {
      float: left;
      background: #fff;
      color: #bfbfbf;
      border: solid 1px #bfbfbf;
      height: 30px;
      width: 30px;
      line-height: 30px;
      padding: 0;
    }

    .input {
      float: left;
      width: 60px;
      height: 30px;
      margin: 0 5px;
      border: solid 1px #bfbfbf;
      text-align: center;
    }

    .disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }
  }
}
</style>
